/* eslint-disable prettier/prettier */
import localize from '../../localize';

export default {
  'taxonomies.Tjeneste': localize('refinementTilbud')
    ? localize('refinementTilbud')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Fylke': localize('refinementFylke')
    ? localize('refinementFylke')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};
